$(document).ready(function(){
  $("#1-mask").mask('(000)-000-0000');
  $("#2-mask").mask('+23-000-0000');
  $("#3-mask").mask('00/00/0000');
  $("#4-mask").mask('00-00-0000');
  $("#5-mask").mask('$000,000,000.00');
  $("#6-mask").mask('AAAA-AAAA-AAAA-AAAA');
  $("#7-mask").mask('000.000.000.000');
});
